"use client";
import { jsx } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import cx from "classnames";
import {
  SkapaFocusLock,
  Events as FocusLockEvents
} from "@ingka/focus-lock-shared";
const FocusLock = (props) => {
  const {
    prefix = "",
    locked = false,
    autoFocus = false,
    escapeHotkey,
    capturePointerEvents = true,
    onEscaped,
    autoFocusReturn = true,
    children,
    className,
    ...other
  } = props;
  const ref = useRef(null);
  const focusTrap = useRef();
  const [escaped, setEscaped] = useState(false);
  const baseClass = `${prefix}skapa-focus-lock`;
  const classes = cx(
    baseClass,
    (!locked || escaped) && `${baseClass}--disabled`,
    className
  );
  const handleEscape = function() {
    if (onEscaped)
      onEscaped();
    setEscaped(true);
  };
  useEffect(() => {
    if (ref.current) {
      if (!focusTrap.current)
        focusTrap.current = new SkapaFocusLock(ref.current);
      const trapInstance = focusTrap.current;
      if (escapeHotkey)
        trapInstance.setDisableKey(escapeHotkey);
      trapInstance.capturePointerEvents = capturePointerEvents;
      trapInstance.autoFocus = autoFocus;
      trapInstance.autoFocusReturn = autoFocusReturn;
      trapInstance.active = locked;
    }
    return () => {
      if (focusTrap.current) {
        focusTrap.current.active = false;
        setEscaped(false);
      }
    };
  }, []);
  useEffect(() => {
    const trapInstance = focusTrap.current;
    if (trapInstance) {
      trapInstance.addEventListener(FocusLockEvents.Escape, handleEscape);
    }
    return () => {
      if (!trapInstance) {
        return;
      }
      trapInstance.removeEventListener(FocusLockEvents.Escape, handleEscape);
    };
  }, [onEscaped, focusTrap.current]);
  useEffect(() => {
    if (focusTrap.current)
      focusTrap.current.active = locked;
    setEscaped(false);
  }, [locked]);
  useEffect(() => {
    if (focusTrap.current)
      focusTrap.current.autoFocus = autoFocus;
  }, [autoFocus]);
  useEffect(() => {
    if (focusTrap.current)
      focusTrap.current.autoFocusReturn = autoFocusReturn;
  }, [autoFocusReturn]);
  useEffect(() => {
    if (focusTrap.current)
      focusTrap.current.setDisableKey(escapeHotkey);
  }, [escapeHotkey]);
  useEffect(() => {
    if (focusTrap.current)
      focusTrap.current.capturePointerEvents = capturePointerEvents;
  }, [capturePointerEvents]);
  return /* @__PURE__ */ jsx("div", { ref, className: classes, ...other, children });
};
var FocusLock_default = FocusLock;
export {
  FocusLock_default as default
};
